import { Component } from 'react';
import PropTypes from 'prop-types';
import DOM from './filterSidebar';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class FilterSidebar extends Component {
    constructor(props) {
        super(props);
        this.view = DOM;
        this.state = {
            filterSidebar: props.displayFilter,
        };
        props.registerCloseSidebar(this.closeSidebar.bind(this));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { destroyFilter } = this.props;
        const { destroyFilter: prevDestroyFilter } = prevProps;
        if (destroyFilter !== prevDestroyFilter && destroyFilter) {
            this.setState({ filterSidebar: false });
        }
    }

    toggleFilterSidebar = () => {
        const { filterSidebar } = this.state;
        const { onToggleFilterSidebar } = this.props;
        this.setState({
            filterSidebar: !filterSidebar,
        });
        if (onToggleFilterSidebar) onToggleFilterSidebar();
    };

    closeSidebar() {
        this.setState({ filterSidebar: false });
    }

    render() {
        return this.view(this.props);
    }
}

FilterSidebar.defaultProps = {
    registerCloseSidebar: () => null,
    displayFilter: false,
    destroyFilter: false,
    onToggleFilterSidebar: () => {},
};

FilterSidebar.propTypes = {
    registerCloseSidebar: PropTypes.func,
    displayFilter: PropTypes.bool,
    destroyFilter: PropTypes.bool,
    onToggleFilterSidebar: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        user: state.user,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(FilterSidebar);
